export default "__VITE_ASSET__CzSQ0tBp__"